export default function GenerateToken(token) {
  return `Bearer ${token}`;
}
